export default __webpack_public_path__ + "static/media/down-arw.8599c50f.svg";